import '../styles/index.scss';
import 'slick-carousel/slick/slick';
import 'lightbox2/dist/js/lightbox-plus-jquery.min';
import 'jquery-ui/dist/jquery-ui.min';
import ImageZoom from 'js-image-zoom/js-image-zoom';
import 'bootstrap';
import functions from './functions';
import cartPage from './cart-page';
import cartFunctions from './cart-functions';
import checkoutPage from './checkout-page';
import navigation from './navigation';
import sliders from './carousel';
import quantity from './quantity-input';
import productPage from './product-page';
import copyToClipboard from "./copy-to-clipboard";
import tabsPanel from './tabs-panel';
import sidebar from './sidebar-list';
import filters from './filters';
import accountPage from './my-account';
import accordionPanel from './accordion-panel';
import popups from "./popup";
import faqPage from "./faq-page";
import ordersShoMore from './my-account-orders-show-more';
import addToCart from './add-to-cart';
import search from './search';
import cookies from './cookies';
import news from './newsletter';
import category from './category-page';
import reviewForm from './reviews-form';
import productPageRating from "./product-page-rating";
import registerNewsletter from "./register";
import {validateRegisterForm} from "./form";

class Main {
    constructor(){
        this.onDOMLoaded();
        this.onDocumentLoad();
        this.onResize();
        this.onScroll();
        window.jQuery = window.$ = $;
    }

    onDocumentLoad(){
        window.addEventListener("load", (event) => {
            copyToClipboard.copyToClipboard();
            quantity.init();
            cookies.newCookies();
            functions.captureHash();
        });
    }

    onDOMLoaded(){
        document.addEventListener("DOMContentLoaded", (event) => {
            sliders.headerBarCarousel();
            sliders.productSliders();
            sliders.companySlider();
            sliders.mainBanner();
            sliders.sectionProductsCarousel();
            tabsPanel.init();
            faqPage.init();
            sidebar.init();
            if ($('.categories__filters__title').length) {
                filters.init();
            }
            cartFunctions.updateCartPageOnChange();
            registerNewsletter.registerNewsletter();
            filters.getFilteredProducts();
            ordersShoMore.ordersShoMore();
            popups.init();
            navigation.init();
            accordionPanel.init();
            cartPage.init();
            checkoutPage.init();
            functions.showTooltip();
            productPage.init();
            accountPage.init();
            addToCart.addToCartProduct();
            search.searchForProducts();
            cartFunctions.removeFromCart();
            news.newsletterAdd();
            category.readMoreButton();
            reviewForm.init();
            productPageRating.init();

            $.scroll_to_notices = function (scrollElement){
                var offset = 2000;
                if (scrollElement.length) {
                    $('html, body').animate({
                        scrollTop: (scrollElement.offset().top - offset)
                    }, 2000);
                }
            };
            $('form.woocommerce-checkout').on('submit', function (){
                $.scroll_to_notices($('body'));
            });

            $(document).ajaxComplete(function (){
                if ($('body').hasClass('woocommerce-checkout') || $('body').hasClass('woocommerce-cart')) {
                    jQuery('html, body').stop();
                }
            });
            $('.woocommerce-form-register__submit').on('click', function (e){
                if (!validateRegisterForm()) {
                    e.preventDefault();
                }
            });
        });
    }

    onResize(){
        window.addEventListener('resize', (event) => {

        });
    }

    onScroll(){
        window.addEventListener('scroll', (event) => {

        });
    }

}

new Main();





// WEBPACK FOOTER //
// ./src/scripts/index.js